import { render, staticRenderFns } from "./destacados.vue?vue&type=template&id=4dec290b&scoped=true"
import script from "./destacados.vue?vue&type=script&lang=js"
export * from "./destacados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec290b",
  null
  
)

export default component.exports